import React from 'react'

const DocSearchSortRow = (props) => {
    const { viewData } = props;

    return (
        <>
            <span className="uiMenuItemLabel">{viewData.dataList.label}</span>
        </>
    )
}

export default DocSearchSortRow